import BoFWaitlist from './bof-waitlist'

export default BoFWaitlist
